// DEPENDENCIES
import moment from 'moment';

// CORE COMPONENTS
import Form from 'core/form/Form';

export const INVENTORY_LOCATIONS = [
  {
    label: 'Purchased - At Source Location (PSL)',
    value: 1
  },
  {
    label: 'Purchased - In Transit (PIT)',
    value: 2
  },
  {
    label: 'Incoming New Vehicle from Factory (INC)',
    value: 5
  }
];

export const PURCHASE_METHOD = [
  {
    label: 'Trade',
    value: 1
  },
  {
    label: 'Purchase',
    value: 2
  }
];

export const INVENTORY_SOURCE_IDS = {
  PURCHASE_FROM_CUSTOMER_FOR_INVENTORY: 3,
  MANUFACTURER: 4,
  PURCHASE_FROM_OTHER: 6,
  TRADE: 7,
  DEALER_DX: 8
};

export const LOCATION_TYPE_IDS = {
  CAD: 3
};

export const LOCATION_TYPE = [
  {
    name: 'Purchased - At Source Location',
    key: 'PSL'
  },
  {
    name: 'Purchased - In Transit',
    key: 'PIT'
  },
  {
    name: 'Checked In and At Dealership',
    key: 'CAD'
  },
  {
    name: 'Checked In and Not At Dealership',
    key: 'CND'
  },
  {
    name: 'Incoming New Vehicle from Factory',
    key: 'INC'
  }
];

export const LOCATION_CHECK_LIST = [
  {
    label: 'Purchased - At Source Location (PSL)',
    value: 'PSL'
  },
  {
    label: 'Purchased - In Transit (PIT)',
    value: 'PIT'
  },
  {
    label: 'Incoming New Vehicle from Factory (INC)',
    value: 'INC'
  }
];

export const VEHICLE_INFO_GENERAL = [
  {
    key: 'stock_num',
    label: 'Stock #'
  },
  {
    key: 'vin_num',
    label: 'VIN #'
  },
  {
    key: 'new_used',
    label: 'Type',
    renderValue: value => (!!value ? 'New' : 'Pre-Owned')
  },
  {
    key: 'located_at_dealership',
    name: 'locatedAtDealership',
    label: 'Is The Vehicle Physically At The Dealership?',
    component: props => <Form.YesNo size="sm" {...props} />
  },
  {
    key: 'location_type_id',
    label: 'Location',
    renderValue: value => {
      return value ? `${LOCATION_TYPE[value - 1].name} (${LOCATION_TYPE[value - 1].key})` : '-';
    }
  },
  {
    key: 'location_comments',
    label: 'Location Comments'
  },
  {
    key: 'vehicle_year',
    label: 'Year'
  },
  {
    key: 'make',
    label: 'Make'
  },
  {
    key: 'model',
    label: 'Model'
  },
  {
    key:'model_code',
    label: 'Model Code'
  },
  {
    key: 'vehicle_trim',
    label: 'Trim'
  },
  {
    key: 'body_style',
    label: 'Body Style'
  },
  {
    key: 'engine',
    label: 'Engine'
  },
  {
    key: 'transmission_name',
    label: 'Transmission'
  },
  {
    key: 'drivetrain_name',
    label: 'Drivetrain'
  },
  {
    key: 'ext_color',
    label: 'Exterior'
  },
  {
    key: 'int_color',
    label: 'Interior'
  },
  {
    key: 'warranty_type_name',
    label: 'Warranty Type'
  },
  {
    key: 'mileage',
    label: 'Mileage'
  }
];

export const VEHICLE_INFO_PURCHASE_INFO = [
  {
    key: 'date_created',
    label: 'Date Added',
    renderValue: value => moment(value).format('MM/DD/YYYY')
  },
  {
    key: 'created_by',
    label: 'Added By'
  },
  {
    key: 'purchase_date',
    label: 'Purchase Date',
    renderValue: value => moment(value).format('MM/DD/YYYY')
  },
  {
    key: 'acquired_salesperson_name',
    label: 'Acquired By',
    forbiddenCodes: ['S', 'PS', 'I']
  },
  {
    key: 'appraised_by',
    label: 'Appraised By',
    forbiddenCodes: ['S', 'PS', 'O', 'I', 'F', 'B']
  },
  {
    key: 'age_of_vehicle',
    label: 'Age',
    renderValue: value => `${value || 0} days`
  },
  {
    key: 'inventory_source_method_name',
    label: 'Source Method',
    hasDate: true,
    dateKey: 'purchase_date'
  },
  {
    key: 'inventory_source',
    label: 'Source'
  },
  {
    key: 'source_name',
    label: 'Source Name'
  }
];

export const INVENTORY_TABS = [
  {
    label: 'Sales',
    sprite: 'delivery-log',
    counterKey: 'salesCount',
    key: 'S'
  },
  {
    label: 'Comments',
    sprite: 'comments',
    counterKey: 'commentsCount',
    key: 'C'
  },
  {
    label: 'Activity',
    sprite: 'activity',
    key: 'A'
  }
];

export const VEHICLE_STATUS = [
  {
    value: 'Sold',
    key: 'S'
  },
  {
    value: 'Pre Stock',
    key: 'PS'
  },
  {
    value: 'Order',
    key: 'O'
  },
  {
    value: 'In Stock',
    key: 'I'
  },
  {
    value: 'Fallout',
    key: 'F'
  },
  {
    value: 'Backout',
    key: 'B'
  }
];

export const TRACKING_TYPES = [
  {
    id: 2,
    key: 'keyInfo',
    label: 'Key Info',
    options: [
      {label: 'Key Not Allocated', value: 1},
      {label: 'Registered in Key Machine', value: 139}
    ]
  },
  {
    id: 3,
    key: 'spareKey',
    label: 'Spare Key',
    options: [
      {label: 'Need to Ask Customer', value: 25},
      {label: 'None', value: 5},
      {label: 'Customer to Provide', value: 6},
      {label: 'Available', value: 7},
      {label: 'Sold/Delivered & Provided to Customer', value: 24}
    ]
  },
  {
    id: 4,
    key: 'homenet',
    label: 'Homenet',
  },
  {
    id: 6,
    key: 'detailCleanUp',
    label: 'Detail & Clean Up',
    options: [
      {label: 'Need to Determine', value: 26},
      {label: 'None', value: 9},
      {label: 'Request / Pending Detail', value: 10},
      {label: 'Request / Pending Clean Up', value: 11},
      {label: 'Completed', value: 12}
    ]
  },
  {
    id: 7,
    key: 'inspection',
    label: 'Inspection',
    options: [
      {label: 'Need to Determine', value: 30},
      {label: 'None', value: 135},
      {label: 'Request / Pending Inspection', value: 133},
      {label: 'Completed', value: 14},
    ]
  },
  {
    id: 8,
    key: 'emission',
    label: 'Emission',
    options: [
      {label: 'Need to Determine', value: 29},
      {label: 'None', value: 136},
      {label: 'Request / Pending', value: 134},
      {label: 'Completed', value: 16},
    ]
  },
  {
    id: 9,
    key: 'photo',
    label: 'Photos',
    options: [
      {label: 'None', value: 137},
      {label: 'No Photos Available', value: 19},
      {label: 'Available', value: 20},
    ]
  },
  {
    id: 10,
    key: 'misc',
    label: 'Miscellaneous',
    options: [
      {label: 'Request / Pending', value: 21},
      {label: 'Completed', value: 22},
    ]
  },
];

export const IMV_ADJUSTMENT_PRICE_OPTIONS = [
  {
    label: 'By Selling Price',
    icon: '$',
    value: 1
  },
  {
    label: 'By Selling Price in %',
    icon: '%',
    value: 2
  },
  {
    label: 'By IMV Price',
    icon: '$',
    value: 3
  },
  {
    label: 'By IMV Price in %',
    icon: '%',
    value: 4
  }
]

export const IMV_ADJUSTMENT_YES_NO_OPTIONS = [
  { label: '+', value: 1 },
  { label: '-', value: 0 }
];

export const IMV_RESULTS_KEYS = [
  {key: 'updatedon', label: 'Updated on'},
  {key: 'adPriced', label: 'Advertised Price'},
  {key: 'imvHigh', label: 'IMV High'},
  {key: 'imvFair', label: 'IMV Fair'},
  {key: 'imvGood', label: 'IMV Good'},
  {key: 'imvGreat', label: 'IMV Great'},
  {key: 'aboveBelowIMF', label: 'Above/Below IMF Fair'},
  {key: 'imvLabel', label: 'IMV Label'}
];